import { t } from "i18next";
import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import OutsideClickHandler from "react-outside-click-handler";
import ConditionalOutsideClick from "../../component/ConditionalOutsideClick";
import moment from "moment";
import AddProfile from "./AddProfile";
import { isEmpty } from "lodash";
const Profile = () => {
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const getProfileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.getProfileData;
  });
  const [select, setSelect] = useState({
    type: "",
    title: "",
    status: false,
  });
  const navigate = useNavigate();
  return ReactDOM.createPortal(
    <app-popup-page
      _ngcontent-serverapp-c4268204220
      className="ng-tns-c4268204220-0 popup-page-wrapper active"
      _nghost-serverapp-c2790459173
    >
      <div
        _ngcontent-serverapp-c2790459173
        className="popup-page popup-page--active popup-page--align-top"
      >
        <div
          _ngcontent-serverapp-c2790459173
          className="popup-page__backdrop"
        />{" "}
        <ConditionalOutsideClick onOutsideClick={() => navigate(-1)}>
          <div
            _ngcontent-serverapp-c2790459173
            className="popup-page__main popup-page-main popup-page-main--show"
          >
            <div
              _ngcontent-serverapp-c2790459173
              className="popup-page-main__header"
            >
              <div
                _ngcontent-serverapp-c2790459173
                className="popup-page-main__title"
              >
                {select?.status ? select?.title : t("PersonalInformation")}
              </div>
              <div
                onClick={() => {
                  select?.status ? setSelect({}) : navigate("/");
                }}
                _ngcontent-serverapp-c2790459173
                className="popup-page-main__close ng-star-inserted"
              />
            </div>
            <div
              _ngcontent-serverapp-c3037944270
              className="popup-page-main__container veirfypopup"
            >
              {select?.status ? (
                <AddProfile
                  select={select}
                  setSelect={setSelect}
                  profileData={profileData}
                  getProfileData={getProfileData}
                />
              ) : (
                <div
                  _ngcontent-serverapp-c3037944270
                  className="content mcd-style player-content new-profile third-party-login"
                >
                  <ng-component
                    _nghost-serverapp-c1360517466
                    className="ng-tns-c1360517466-29 ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c1360517466
                      className="ng-tns-c1360517466-29 player-vip-lv1 ng-star-inserted"
                    >
                      <div
                        _ngcontent-serverapp-c1360517466
                        className="ng-tns-c1360517466-29 player-info-vip"
                        style={{
                          "background-image":
                            'url("/assets/NewImages/vip-card-bg-1.webp?v=1776751585885")',
                        }}
                      >
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="member-pic ng-tns-c1360517466-29"
                        >
                          <span
                            _ngcontent-serverapp-c1360517466
                            className="item-icon ng-tns-c1360517466-29 ng-star-inserted"
                            style={{
                              "background-image":
                                'url("/assets/NewImages/memberpic-lv1.webp?v=1776751585885")',
                            }}
                          />
                        </div>
                      </div>
                      <div
                        _ngcontent-serverapp-c1360517466
                        className="membername-wrap ng-tns-c1360517466-29"
                      >
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="membername ng-tns-c1360517466-29"
                        >
                          {profileData?.username}
                        </div>
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="level ng-tns-c1360517466-29 ng-star-inserted"
                        >
                          {" "}
                          Normal{" "}
                        </div>

                        <br
                          _ngcontent-serverapp-c1360517466
                          className="ng-tns-c1360517466-29"
                        />
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="register-date ng-tns-c1360517466-29"
                        >
                          Date Registered :{" "}
                          <i
                            _ngcontent-serverapp-c1360517466
                            className="ng-tns-c1360517466-29"
                          >
                            {moment(profileData?.createdAt).format(
                              "YYYY/MM/DD",
                            )}
                          </i>
                        </div>
                      </div>
                    </div>
                    <div
                      _ngcontent-serverapp-c1360517466
                      id="profile-vip-div"
                      className="menu-box ng-tns-c1360517466-29 ng-star-inserted"
                    >
                      <div
                        _ngcontent-serverapp-c1360517466
                        className="vip-area-group ng-tns-c1360517466-29"
                      >
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="left-box ng-tns-c1360517466-29"
                        >
                          <div
                            _ngcontent-serverapp-c1360517466
                            className="item ng-tns-c1360517466-29"
                          >
                            <h3
                              _ngcontent-serverapp-c1360517466
                              className="ng-tns-c1360517466-29"
                            >
                              VIP Points (VP)
                            </h3>
                            <div
                              _ngcontent-serverapp-c1360517466
                              className="points-number ng-tns-c1360517466-29"
                            >
                              0
                            </div>
                          </div>
                        </div>
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="right-box ng-tns-c1360517466-29"
                        >
                          <a
                            href="#"
                            _ngcontent-serverapp-c1360517466
                            className="goto-myvip ng-tns-c1360517466-29 ng-star-inserted"
                            // href="/bd/en/member/vip-points-exchange(popup:member/new-profile-info)"
                          >
                            <div
                              _ngcontent-serverapp-c1360517466
                              className="myvip-text ng-tns-c1360517466-29"
                            >
                              <span
                                _ngcontent-serverapp-c1360517466
                                className="ng-tns-c1360517466-29"
                              >
                                {" "}
                                My VIP{" "}
                              </span>
                              <span
                                _ngcontent-serverapp-c1360517466
                                className="item-icon ng-tns-c1360517466-29"
                                style={{
                                  "mask-image":
                                    'url("/assets/NewImages/icon-arrow.webp?v=1776751585885")',
                                }}
                              />
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>

                    <div
                      _ngcontent-serverapp-c1360517466
                      className="ng-tns-c1360517466-29 ng-trigger ng-trigger-slideAnimation ng-star-inserted"
                    >
                      <mcd-verify-tips-box
                        _ngcontent-serverapp-c1360517466
                        className="ng-tns-c1360517466-29"
                        _nghost-serverapp-c541140243
                      >
                        <div
                          _ngcontent-serverapp-c541140243
                          className="tips-info verify-tips tips-info-toggle ng-star-inserted"
                          style={{}}
                        >
                          <div
                            _ngcontent-serverapp-c541140243
                            className="title-box"
                          >
                            <h5 _ngcontent-serverapp-c541140243>
                              <i
                                _ngcontent-serverapp-c541140243
                                className="tips-icon"
                                style={{
                                  "mask-image":
                                    'url("/assets/NewImages/icon-tips-type02.webp?v=1776751585885")',
                                }}
                              />
                              <span _ngcontent-serverapp-c541140243>
                                Please complete the verification below before
                                you proceed with the withdrawal request.
                              </span>
                            </h5>
                            <div
                              _ngcontent-serverapp-c541140243
                              className="toggle-btn ng-star-inserted"
                              style={{
                                "mask-image":
                                  'url("/assets/NewImages/icon-arrow-type09.webp?v=1776751585885")',
                              }}
                            />
                          </div>
                          <ol
                            _ngcontent-serverapp-c541140243
                            className="tips-info-block active"
                          >
                            {/* <li
                              _ngcontent-serverapp-c541140243
                              className="personal-info ng-star-inserted"
                            >
                              <a
                                _ngcontent-serverapp-c541140243
                                className="ng-star-inserted"
                              >
                                <label _ngcontent-serverapp-c541140243>
                                  {" "}
                                  Personal Info{" "}
                                </label>
                                <ul _ngcontent-serverapp-c541140243>
                                  <li
                                    _ngcontent-serverapp-c541140243
                                    className="ng-star-inserted"
                                  >
                                    Full Name
                                  </li>
                                </ul>
                              </a>
                            </li> */}
                            <li
                              _ngcontent-serverapp-c541140243
                              className="contact-info ng-star-inserted"
                            >
                              <a
                                _ngcontent-serverapp-c541140243
                                className="ng-star-inserted"
                              >
                                <label _ngcontent-serverapp-c541140243>
                                  {" "}
                                  Contact Info{" "}
                                </label>
                                <ul _ngcontent-serverapp-c541140243>
                                  <li
                                    _ngcontent-serverapp-c541140243
                                    className="ng-star-inserted"
                                  >
                                    Phone Number
                                  </li>
                                </ul>
                              </a>
                            </li>
                          </ol>
                        </div>
                      </mcd-verify-tips-box>
                    </div>

                    <div
                      _ngcontent-serverapp-c1360517466
                      className="menu-box unverified-block-personal ng-tns-c1360517466-29 ng-star-inserted"
                    >
                      <div
                        _ngcontent-serverapp-c1360517466
                        className="list-group ng-tns-c1360517466-29"
                        name="Full Name"
                      >
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="icon-block ng-tns-c1360517466-29"
                        >
                          <div
                            _ngcontent-serverapp-c1360517466
                            className="item-icon ng-tns-c1360517466-29"
                            style={{
                              "mask-image":
                                'url("/assets/NewImages/icon-username.webp?v=1776751585885")',
                            }}
                          />
                        </div>
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="list ng-tns-c1360517466-29"
                        >
                          <div
                            _ngcontent-serverapp-c1360517466
                            className="list-info ng-tns-c1360517466-29"
                          >
                            <div
                              _ngcontent-serverapp-c1360517466
                              className="left ng-tns-c1360517466-29"
                            >
                              <div
                                _ngcontent-serverapp-c1360517466
                                className="info-block ng-tns-c1360517466-29"
                              >
                                <div
                                  _ngcontent-serverapp-c1360517466
                                  className="ng-tns-c1360517466-29"
                                >
                                  <label
                                    _ngcontent-serverapp-c1360517466
                                    className="title ng-tns-c1360517466-29"
                                  >
                                    Full Name
                                  </label>
                                </div>
                                <label
                                  _ngcontent-serverapp-c1360517466
                                  className="tips ng-tns-c1360517466-29"
                                >
                                  {profileData?.firstName}
                                </label>
                                
                              </div>
                            </div>
                            {isEmpty(profileData?.firstName) && (
                              <div
                                onClick={() =>
                                  setSelect({
                                    type: "fullname",
                                    title: "Add Full Name",
                                    placeholder: "Your full name ...",
                                    label: "Full Name",
                                    status: true,
                                  })
                                }
                                _ngcontent-serverapp-c1360517466
                                className="right ng-tns-c1360517466-29"
                              >
                                <button
                                  _ngcontent-serverapp-c1360517466
                                  className="button ng-tns-c1360517466-29 ng-star-inserted"
                                >
                                  Add
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div
                        _ngcontent-serverapp-c2409418650
                        className="list-group ng-tns-c2409418650-15"
                        name="Birthday"
                      >
                        <div
                          _ngcontent-serverapp-c2409418650
                          className="icon-block ng-tns-c2409418650-15"
                        >
                          <div
                            _ngcontent-serverapp-c2409418650
                            className="item-icon ng-tns-c2409418650-15"
                            style={{
                              "mask-image":
                                'url("https://img.b426b.com/bb/h5/assets/images/icon-set/player/icon-birthday.svg?v=1777968966408")',
                            }}
                          />
                        </div>
                        <div
                          _ngcontent-serverapp-c2409418650
                          className="list ng-tns-c2409418650-15"
                        >
                          <div
                            _ngcontent-serverapp-c2409418650
                            className="list-info ng-tns-c2409418650-15"
                          >
                            {/* <div
                              _ngcontent-serverapp-c2409418650
                              className="left ng-tns-c2409418650-15"
                            >
                              <div
                                _ngcontent-serverapp-c2409418650
                                className="info-block ng-tns-c2409418650-15"
                              >
                                <div
                                  _ngcontent-serverapp-c2409418650
                                  className="ng-tns-c2409418650-15"
                                >
                                  <label
                                    _ngcontent-serverapp-c2409418650
                                    className="title ng-tns-c2409418650-15"
                                  >
                                    Birthday
                                  </label>
                                  <label
                                    _ngcontent-serverapp-c2409418650
                                    className="ng-tns-c2409418650-15"
                                  />
                                </div>
                                <label
                                  _ngcontent-serverapp-c1360517466
                                  className="tips ng-tns-c1360517466-29"
                                >
                                  {profileData?.dob}
                                </label>
                              </div>
                            </div> */}
                            {/* {isEmpty(profileData?.dob) && (
                              <div
                                onClick={() =>
                                  setSelect({
                                    type: "birthday",
                                    title: "Add Birthday",
                                    placeholder: "Your birthday ...",
                                    label: "Birthday",
                                    status: true,
                                  })
                                }
                                _ngcontent-serverapp-c2409418650
                                className="right ng-tns-c2409418650-15"
                              >
                                <button
                                  _ngcontent-serverapp-c2409418650
                                  className="button ng-tns-c2409418650-15 ng-star-inserted"
                                >
                                  Add
                                </button>
                              </div>
                            )} */}
                          </div>
                        </div>
                      </div>
                      <div
                        _ngcontent-serverapp-c1360517466
                        className="list-group ng-tns-c1360517466-29"
                        name="Phone Number"
                      >
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="icon-block ng-tns-c1360517466-29"
                        >
                          <div
                            _ngcontent-serverapp-c1360517466
                            className="item-icon ng-tns-c1360517466-29"
                            style={{
                              "mask-image":
                                'url("/assets/NewImages/icon-phone.webp?v=1776751585885")',
                            }}
                          />
                        </div>
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="list phone ng-tns-c1360517466-29"
                        >
                          <div
                            _ngcontent-serverapp-c1360517466
                            className="list-info ng-tns-c1360517466-29 ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c1360517466
                              className="left ng-tns-c1360517466-29"
                            >
                              <div
                                _ngcontent-serverapp-c1360517466
                                className="info-block ng-tns-c1360517466-29"
                              >
                                <div
                                  _ngcontent-serverapp-c1360517466
                                  className="ng-tns-c1360517466-29"
                                >
                                  <label
                                    _ngcontent-serverapp-c1360517466
                                    className="title ng-tns-c1360517466-29"
                                  >
                                    Phone Number{" "}
                                  </label>
                                </div>
                                <label
                                  _ngcontent-serverapp-c1360517466
                                  className="tips ng-tns-c1360517466-29"
                                >
                                  {profileData?.phone}
                                </label>
                              </div>
                                <div
                                _ngcontent-serverapp-c1360517466
                                className="info-block ng-tns-c1360517466-29"
                              >
                                <div
                                  _ngcontent-serverapp-c1360517466
                                  className="ng-tns-c1360517466-29"
                                >
                                  <label
                                    _ngcontent-serverapp-c1360517466
                                    className="title ng-tns-c1360517466-29"
                                  >
                                    Temporary Phone Number{" "}
                                  </label>
                                </div>
                                <label
                                  _ngcontent-serverapp-c1360517466
                                  className="tips ng-tns-c1360517466-29"
                                >
                                  {profileData?.temporaryPhone || '-'}
                                </label>
                              </div>
                            </div>

                            {/* <div
                              onClick={() => {
                                if (!profileData?.isVerified) {
                                  setSelect({
                                    type: "phone",
                                    title: "Verfiy Phone Number",
                                    placeholder: "Your phone number ...",
                                    label: "Phone Number",
                                    status: true,
                                    statusPhone: false,
                                    phone: profileData?.phone,
                                  });
                                }
                              }}
                              _ngcontent-serverapp-c1360517466
                              className="right ng-tns-c1360517466-29"
                            >
                              <div
                                _ngcontent-serverapp-c1360517466
                                className={`status ${profileData?.isVerified ? "confirm-btn" : "unconfirm-btn"} ng-tns-c1360517466-29 ng-star-inserted`}
                              >
                                {" "}
                                {profileData?.isVerified
                                  ? "Verified"
                                  : "Not Verified"}{" "}
                              </div>
                            </div> */}
                          </div>

                          {/* {profileData?.isVerified && (
                            <button
                              onClick={() => {
                                setSelect({
                                  type: "phone",
                                  title: "Add Phone Number",
                                  placeholder: "Add new phone number ...",
                                  label: "Phone Number",
                                  status: true,
                                  statusPhone: true,
                                  phone: profileData?.phone,
                                });
                              }}
                              style={{ marginTop: "5px" }}
                              class="button ng-tns-c2409418650-15 ng-star-inserted"
                            >
                              + Add
                            </button>
                          )} */}
                        </div>
                      </div>
                      {/* <div
                        _ngcontent-serverapp-c1360517466
                        id="profile-email"
                        className="list-group ng-tns-c1360517466-29"
                        name="E-mail"
                      >
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="icon-block ng-tns-c1360517466-29"
                        >
                          <div
                            _ngcontent-serverapp-c1360517466
                            className="item-icon ng-tns-c1360517466-29"
                            style={{
                              "mask-image":
                                'url("/assets/NewImages/icon-email.webp?v=1776751585885")',
                            }}
                          />
                        </div>
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="list ng-tns-c1360517466-29"
                        >
                          <div
                            _ngcontent-serverapp-c1360517466
                            className="list-info ng-tns-c1360517466-29 ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c1360517466
                              className="left ng-tns-c1360517466-29"
                            >
                              <div
                                _ngcontent-serverapp-c1360517466
                                className="info-block ng-tns-c1360517466-29"
                              >
                                <div
                                  _ngcontent-serverapp-c1360517466
                                  className="ng-tns-c1360517466-29"
                                >
                                  <label
                                    _ngcontent-serverapp-c1360517466
                                    className="title ng-tns-c1360517466-29"
                                  >
                                    Email
                                  </label>
                                </div>
                                <label
                                  _ngcontent-serverapp-c1360517466
                                  className="tips ng-tns-c1360517466-29"
                                >
                                  {profileData?.email}
                                </label>
                              </div>
                            </div>
                            {isEmpty(profileData?.email) && (
                              <div
                                onClick={() =>
                                  setSelect({
                                    type: "email",
                                    title: "Add Email",
                                    placeholder: "Your email address ...",
                                    label: "Email",
                                    status: true,
                                  })
                                }
                                _ngcontent-serverapp-c1360517466
                                className="right ng-tns-c1360517466-29"
                              >
                                <button
                                  _ngcontent-serverapp-c1360517466
                                  className="button ng-tns-c1360517466-29"
                                >
                                  Add
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div> */}
                    </div>
                    <div
                      _ngcontent-serverapp-c1360517466
                      className="member-menu-point ng-tns-c1360517466-29 ng-star-inserted"
                    >
                      <i
                        _ngcontent-serverapp-c1360517466
                        className="ng-tns-c1360517466-29"
                      >
                        <span
                          _ngcontent-serverapp-c1360517466
                          className="item-icon ng-tns-c1360517466-29"
                          style={{
                            "background-image":
                              'url("/assets/NewImages/icon-customer.webp?v=1776751585885")',
                          }}
                        />
                      </i>
                      <p
                        _ngcontent-serverapp-c1360517466
                        className="ng-tns-c1360517466-29"
                      >
                        For privacy and security, Information can’t modified
                        after confirmation. Please{" "}
                        <span
                          _ngcontent-serverapp-c1360517466
                          name="liveChatBtn"
                          className="ng-tns-c1360517466-29"
                        >
                          contact customer service
                        </span>{" "}
                        .
                      </p>
                    </div>
                  </ng-component>
                </div>
              )}
            </div>
          </div>
        </ConditionalOutsideClick>
      </div>
    </app-popup-page>,
    document.getElementById("overlay"),
  );
};

export default Profile;
